<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            供应商列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd"   @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit"  @click="toggleModalEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入供应商名称" v-model="name" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-select
                            v-model="status"
                            style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="(item,i) in statusValue"
                                :key="i"
                                :label="item"
                                :value="i">
                            </el-option>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData"  v-loading="loading" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick' >

                        <el-table-column prop="name" label="名称"></el-table-column>

                        <el-table-column prop="phone" label="手机"></el-table-column>

                        <el-table-column prop="address" label="地址"></el-table-column>

                        <el-table-column prop="sort" label="排序"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                disabledAdd:true,
                menuButtonList:null,
                disabledEdit:true,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                status:0,
                statusValue:['供应商状态','正常','禁用'],
                totalItems: 0,
                name: '',
                pageSize:20,
                currentPage:1,
                th:0,
                row:null,
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Supplier/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        status:this.status-1,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                
            },
        }
    }
</script>

<style lang='scss' scoped>
 /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
